// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-button{border-radius:6px;font-size:16px;height:40px}.van-button--info{background-color:#2496ff;border-color:#2496ff}.van-button:active{background-color:#077ae5;border-color:#077ae5}.button-general{background-color:#fff;border-color:#2496ff;color:#2496ff}.can-hover:hover{background-color:#83c3ff;border-color:#83c3ff}", ""]);
// Exports
module.exports = exports;
